import React, { useState, useEffect, useMemo } from "react";
import Content from "../../components/Content";
import Layout from "../../containers/LayoutAdministrativo";
import ListasPreciosService from "../../services/ListasPreciosService";
import EstudiosService from "../../services/EstudiosService";
import PreciosEstudioService from "../../services/PreciosEstudioService";
import EstudiosIntService from "../../services/EstudiosIntService";
import AreasService from "../../services/AreasService";
import MuestrasService from "../../services/MuestrasService";
import MaterialesService from "../../services/MaterialesService";
import SinonimosService from "../../services/SinonimosService";
import SucursalesService from "../../services/SucursalesService";
import TelefonosService from "../../services/TelefonosService";

import logoLaboratorio from "../../img/logo-laboratorio.jpg";
import Icon from "@mdi/react";
import { mdiFilePdfBox } from "@mdi/js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { ejecutarConCargandoPDF } from "../../utils/pdfLoadingUtils";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import {
  Select,
  MenuItem,
  Paper,
  Typography,
  Stack,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  IconButton,
  Tooltip,
  tooltipClasses,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
} from "@mui/material";
import Swal from "sweetalert2";

const CatalogoEstudios = () => {
  const [listasPrecios, setListasPrecios] = useState([]);
  const [listaSeleccionada, setListaSeleccionada] = useState("");
  const [estudiosList, setEstudiosList] = useState([]);
  const [detallesMap, setDetallesMap] = useState({});
  const [preciosByLista, setPreciosByLista] = useState({});
  const [areasMap, setAreasMap] = useState({});
  const [materialesMap, setMaterialesMap] = useState({});
  const [subEstudiosMap, setSubEstudiosMap] = useState({});
  const [sinonimosMap, setSinonimosMap] = useState({});
  const [muestrasMap, setMuestrasMap] = useState({});
  const [sucursales, setSucursales] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtros
  const [tipoEstudio, setTipoEstudio] = useState(true);
  const [tipoPerfil, setTipoPerfil] = useState(true);
  const [ordenamiento, setOrdenamiento] = useState("nombre"); // "codigo" | "nombre" | "area"
  const [subrogadoSi, setSubrogadoSi] = useState(true);
  const [subrogadoNo, setSubrogadoNo] = useState(true);

  // Costos a mostrar
  const [costoSubrogadoCheck, setCostoSubrogadoCheck] = useState(true);
  const [costoPublicoCheck, setCostoPublicoCheck] = useState(true);
  const [costoInternoCheck, setCostoInternoCheck] = useState(true);

  // Indicaciones a mostrar
  const [indPacienteCheck, setIndPacienteCheck] = useState(true);
  const [indTomaCheck, setIndTomaCheck] = useState(true);
  const [indEstabilidadCheck, setIndEstabilidadCheck] = useState(true);

  // Paginación (50 por página)
  const [page, setPage] = useState(1);
  const itemsPerPage = 50;

  useEffect(() => {
    document.title = "Catálogo de Estudios";
    fetchDatosIniciales();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Función para convertir texto enriquecido (ReactQuill HTML) a texto plano manteniendo formato y saltos de línea
  const convertRichTextToPlainText = (html) => {
    if (!html) return "";
    let str = String(html).trim();
    if (!str) return "";

    // Reemplazar saltos de línea HTML y cierres de párrafo / viñetas
    str = str.replace(/<br\s*\/?>/gi, "\n");
    str = str.replace(/<\/p>/gi, "\n");
    str = str.replace(/<\/div>/gi, "\n");
    str = str.replace(/<\/h[1-6]>/gi, "\n");
    str = str.replace(/<\/li>/gi, "\n");
    str = str.replace(/<li[^>]*>/gi, "• ");

    // Usar DOMParser para extraer el texto plano limpio
    let text = "";
    try {
      const doc = new DOMParser().parseFromString(str, "text/html");
      text = doc.body.textContent || doc.body.innerText || "";
    } catch (e) {
      text = str.replace(/<[^>]+>/g, "");
    }

    // Reemplazar espacios duros HTML &nbsp; e invisibles
    text = text
      .replace(/\u00a0/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/\r\n/g, "\n")
      .replace(/\n\s*\n/g, "\n")
      .trim();

    return text;
  };

  const fetchDatosIniciales = async () => {
    setLoading(true);
    try {
      const [resListas, resEst, resPrecios, resAreas, resSuc, resMat] = await Promise.all([
        ListasPreciosService.getListas().catch(() => ({ data: [] })),
        EstudiosService.getEstudios().catch(() => ({ data: [] })),
        PreciosEstudioService.getPrecios().catch(() => ({ data: { precios: [] } })),
        AreasService.getAreas().catch(() => ({ data: [] })),
        SucursalesService.getSucursales().catch(() => ({ data: [] })),
        MaterialesService.getMateriales().catch(() => ({ data: [] })),
      ]);

      const listaListas = Array.isArray(resListas?.data?.listas)
        ? resListas.data.listas
        : Array.isArray(resListas?.data)
          ? resListas.data
          : [];

      const listaEst = Array.isArray(resEst?.data?.estudios)
        ? resEst.data.estudios
        : Array.isArray(resEst?.data)
          ? resEst.data
          : [];

      const listaPreciosData = Array.isArray(resPrecios?.data?.precios)
        ? resPrecios.data.precios
        : Array.isArray(resPrecios?.data)
          ? resPrecios.data
          : [];

      const listaAreas = Array.isArray(resAreas?.data?.areas)
        ? resAreas.data.areas
        : Array.isArray(resAreas?.data)
          ? resAreas.data
          : [];

      const listaSuc = Array.isArray(resSuc?.data?.sucursales)
        ? resSuc.data.sucursales
        : Array.isArray(resSuc?.data)
          ? resSuc.data
          : [];

      const listaMat = Array.isArray(resMat?.data?.materiales)
        ? resMat.data.materiales
        : Array.isArray(resMat?.data)
          ? resMat.data
          : [];

      // Mapear áreas
      const aMap = {};
      listaAreas.forEach((a) => {
        if (a && a.idArea) {
          aMap[a.idArea] = a.nombre || a.nombreArea || "";
        }
      });

      // Mapear materiales/tubos
      const matMap = {};
      listaMat.forEach((m) => {
        if (m && m.idMaterial) {
          matMap[m.idMaterial] = m.nombre || m.descripcion || m.colorTubo || m.material || "";
        }
      });

      // Mapear precios por lista y estudio
      const pMap = {};
      listaPreciosData.forEach((p) => {
        if (p && p.idListaPrecio && p.idEstudio) {
          if (!pMap[p.idListaPrecio]) pMap[p.idListaPrecio] = {};
          pMap[p.idListaPrecio][p.idEstudio] = Number(p.precio ?? 0);
        }
      });

      setListasPrecios(listaListas);
      setEstudiosList(listaEst);
      setPreciosByLista(pMap);
      setAreasMap(aMap);
      setMaterialesMap(matMap);
      setSucursales(listaSuc);

      if (listaListas.length > 0) {
        setListaSeleccionada(String(listaListas[0].idListaPrecio || listaListas[0].idLista));
      }

      // Cargar detalles completos de estudios (getEstudioPorId), subestudios, muestras y sinónimos
      const detMap = {};
      const subMap = {};
      const sinMap = {};
      const muesMap = {};

      await Promise.all(
        listaEst.map(async (est) => {
          if (est && est.idEstudio) {
            try {
              const estDetalle = await EstudiosService.getEstudioPorId(est.idEstudio);
              if (estDetalle) {
                detMap[est.idEstudio] = estDetalle;
              }
            } catch (e) { }

            try {
              const resSub = await EstudiosIntService.getEstudiosPorEstudio(est.idEstudio);
              if (Array.isArray(resSub) && resSub.length > 0) {
                subMap[est.idEstudio] = resSub;
              }
            } catch (e) { }

            try {
              const resMuestras = await MuestrasService.getMuestrasPorEstudio(est.idEstudio);
              const arrM = Array.isArray(resMuestras) ? resMuestras : resMuestras?.muestras || [];
              if (arrM.length > 0) {
                muesMap[est.idEstudio] = arrM;
              }
            } catch (e) { }

            try {
              const resSin = await SinonimosService.getSinonimosPorEstudio(est.idEstudio);
              const arrSin = Array.isArray(resSin) ? resSin : resSin?.sinonimos || [];
              if (arrSin.length > 0) {
                sinMap[est.idEstudio] = arrSin.map((s) => (typeof s === "string" ? s : s.sinonimo || s.nombre || ""));
              }
            } catch (e) { }
          }
        })
      );

      setDetallesMap(detMap);
      setSubEstudiosMap(subMap);
      setSinonimosMap(sinMap);
      setMuestrasMap(muesMap);
    } catch (error) {
      console.error("Error cargando datos para Catálogo de Estudios:", error);
      Swal.fire({
        title: "¡Error!",
        text: "Ocurrió un error al consultar el catálogo de estudios del servidor.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } finally {
      setLoading(false);
    }
  };

  // Determinar si un estudio es un perfil
  const esPerfilEstudio = (est) => {
    if (!est) return false;
    const estDet = detallesMap[est.idEstudio] || est;
    const subArr = subEstudiosMap[est.idEstudio];
    if (subArr && subArr.length > 0) return true;
    return (
      estDet.esPerfil === 1 ||
      estDet.esPerfil === true ||
      estDet.esPerfil === "1" ||
      `${estDet.tipo}`.toLowerCase() === "perfil" ||
      est.esPerfil === 1 ||
      est.esPerfil === true ||
      `${est.tipo}`.toLowerCase() === "perfil"
    );
  };

  // Determinar si un estudio es subrogado
  const esSubrogadoEstudio = (est) => {
    if (!est) return false;
    const estDet = detallesMap[est.idEstudio] || est;
    return (
      estDet.esSubrogado === 1 ||
      estDet.esSubrogado === true ||
      estDet.esSubrogado === "1" ||
      estDet.subrogado === true ||
      `${estDet.subrogado}`.toLowerCase() === "si" ||
      `${estDet.subrogado}`.toLowerCase() === "1" ||
      est.esSubrogado === 1 ||
      est.esSubrogado === true
    );
  };

  // Extraer información detallada del estudio y de sus muestras
  const getDetallesEstudio = (est) => {
    const estDet = detallesMap[est.idEstudio] || est;
    const muestrasArr = muestrasMap[est.idEstudio] || [];
    const mObj = muestrasArr[0] || {};

    const abrev = estDet.abreviaturaMuestra || estDet.abreviatura || est.abreviaturaMuestra || est.abreviatura || mObj.abreviatura || mObj.abreviaturaMuestra || "-";
    const tipoM = estDet.tipoMuestra || estDet.nombreMuestra || est.tipoMuestra || est.nombreMuestra || mObj.tipoMuestra || mObj.nombreMuestra || mObj.nombre || "-";

    // Cantidad y Unidad de Medida en muestras
    const cant = estDet.cantidad || estDet.volCant || estDet.volumenCantidad || estDet.volumen || est.cantidad || est.volCant || est.volumenCantidad || est.volumen || mObj.cantidad || mObj.volCant || mObj.volumenCantidad || mObj.volumen || "";
    const um = estDet.unidadMedida || estDet.um || est.unidadMedida || est.um || mObj.unidadMedida || mObj.um || "";
    const volCant = cant ? `${cant} ${um}`.trim() : (um ? um : "-");

    // Color tubo / material
    const matId = estDet.idMaterial || est.idMaterial || mObj.idMaterial;
    const colorTub = estDet.colorTubo || estDet.material || estDet.colorTuboMaterial || est.colorTubo || est.material || est.colorTuboMaterial || mObj.colorTubo || mObj.material || mObj.colorTuboMaterial || mObj.nombreMaterial || materialesMap[matId] || "-";

    // Tiempo proceso (tiempo de entrega en días)
    let rawEntrega = estDet.tiempoEntrega || estDet.tiempoEntregaN || est.tiempoEntrega || est.tiempoEntregaN || mObj.tiempoEntrega || "";
    let tProc = "-";
    if (rawEntrega && String(rawEntrega).trim() !== "" && String(rawEntrega).trim() !== "null") {
      const strProc = String(rawEntrega).trim();
      if (!/d[ií]a|hora|minuto/i.test(strProc)) {
        tProc = `${strProc} días`;
      } else {
        tProc = strProc;
      }
    }

    // Tiempo urgente (tiempo de proceso urgente en días u horas)
    let rawProceso = estDet.tiempoProceso ?? estDet.tiempoProcesoN ?? est.tiempoProceso ?? est.tiempoProcesoN ?? mObj.tiempoProceso;
    let unitProceso = estDet.tiempoProcesoDH || estDet.tiempoProcesoDHN || est.tiempoProcesoDH || est.tiempoProcesoDHN || mObj.tiempoProcesoDH || "";
    let tUrg = "-";
    if (rawProceso !== null && rawProceso !== undefined && String(rawProceso).trim() !== "" && String(rawProceso).trim() !== "null") {
      const strUrg = String(rawProceso).trim();
      if (!/d[ií]a|hora|minuto/i.test(strUrg)) {
        const unitStr = unitProceso && unitProceso !== "seleccione" ? unitProceso : "horas";
        tUrg = `${strUrg} ${unitStr}`;
      } else {
        tUrg = strUrg;
      }
    }

    // Método / Metodología / Técnica
    const met = estDet.metodo || estDet.metodologia || estDet.nombreMetodo || estDet.tecnica || est.metodo || est.metodologia || est.nombreMetodo || est.tecnica || mObj.metodo || mObj.metodologia || mObj.tecnica || "-";

    // Indicaciones
    let indPacText = estDet.indicacionesPaciente || estDet.indicacionPaciente || estDet.condicionesPaciente || est.indicacionesPaciente || est.indicacionPaciente || est.condicionesPaciente || mObj.indicacionesPaciente || mObj.indicacionPaciente || mObj.condicionesPaciente || "";
    let indTomaText = estDet.indicacionesToma || estDet.indicacionToma || est.indicacionesToma || est.indicacionToma || mObj.indicacionesToma || mObj.indicacionToma || "";
    let indEstText = estDet.indicacionesEstabilidad || estDet.indicacionEstabilidad || est.indicacionesEstabilidad || est.indicacionEstabilidad || mObj.indicacionesEstabilidad || mObj.indicacionEstabilidad || "";

    if (!indPacText && muestrasArr.length > 0) {
      indPacText = muestrasArr.map((m) => m.indicacionesPaciente || m.condicionesPaciente || m.indicacionPaciente).filter(Boolean).join("\n");
    }
    if (!indTomaText && muestrasArr.length > 0) {
      indTomaText = muestrasArr.map((m) => m.indicacionesToma || m.indicacionToma).filter(Boolean).join("\n");
    }
    if (!indEstText && muestrasArr.length > 0) {
      indEstText = muestrasArr.map((m) => m.indicacionesEstabilidad || m.indicacionEstabilidad).filter(Boolean).join("\n");
    }

    return {
      abrev,
      tipoM,
      volCant,
      colorTub,
      tProc,
      tUrg,
      met,
      indPacText,
      indTomaText,
      indEstText,
    };
  };

  // Filtrado y ordenamiento de estudios
  const estudiosFiltrados = useMemo(() => {
    let result = estudiosList.filter((est) => {
      const esPerf = esPerfilEstudio(est);

      // Filtro Tipo
      if (tipoEstudio && tipoPerfil) {
        // Ambas opciones seleccionadas
      } else if (tipoEstudio && !tipoPerfil) {
        if (esPerf) return false;
      } else if (!tipoEstudio && tipoPerfil) {
        if (!esPerf) return false;
      } else {
        return false;
      }

      // Filtro Subrogado
      const esSub = esSubrogadoEstudio(est);
      if (subrogadoSi && subrogadoNo) {
        // Ambas opciones seleccionadas
      } else if (subrogadoSi && !subrogadoNo) {
        if (!esSub) return false;
      } else if (!subrogadoSi && subrogadoNo) {
        if (esSub) return false;
      } else {
        return false;
      }

      return true;
    });

    // Ordenamiento
    if (ordenamiento === "codigo") {
      result.sort((a, b) => String(a.codigo || "").localeCompare(String(b.codigo || "")));
    } else if (ordenamiento === "nombre") {
      result.sort((a, b) => String(a.nombre || "").localeCompare(String(b.nombre || "")));
    } else if (ordenamiento === "area") {
      result.sort((a, b) => {
        const areaA = String(areasMap[a.idArea] || a.nombreArea || a.area || "General");
        const areaB = String(areasMap[b.idArea] || b.nombreArea || b.area || "General");
        const compArea = areaA.localeCompare(areaB);
        if (compArea !== 0) return compArea;
        return String(a.nombre || "").localeCompare(String(b.nombre || ""));
      });
    }

    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    estudiosList,
    detallesMap,
    tipoEstudio,
    tipoPerfil,
    ordenamiento,
    subrogadoSi,
    subrogadoNo,
    subEstudiosMap,
    areasMap,
  ]);

  // Paginación: 50 por página
  const totalPages = Math.ceil(estudiosFiltrados.length / itemsPerPage) || 1;
  const estudiosPaginados = useMemo(() => {
    const startIdx = (page - 1) * itemsPerPage;
    return estudiosFiltrados.slice(startIdx, startIdx + itemsPerPage);
  }, [estudiosFiltrados, page]);

  // Calcular arreglo de páginas visibles estilo ReporteCaja.js
  const paginasVisibles = useMemo(() => {
    const arr = [];
    let start = Math.max(1, page - 4);
    let end = Math.min(totalPages, start + 8);
    if (end - start < 8) {
      start = Math.max(1, end - 8);
    }
    for (let i = start; i <= end; i++) {
      if (i >= 1 && i <= totalPages) {
        arr.push(i);
      }
    }
    return arr;
  }, [totalPages, page]);

  // Exportación a PDF Institucional (Exporta todos los estudios filtrados sin paginación)
  const handleExportarPDF = async () => {
    if (estudiosFiltrados.length === 0) {
      Swal.fire({
        title: "Sin datos",
        text: "No existen estudios para los filtros seleccionados para exportar a PDF.",
        icon: "info",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    await ejecutarConCargandoPDF(
      async () => {
        const doc = new jsPDF();
        const startY = 12;

    let sucursalActualObj = sucursales[0] || {};
    let sucursalTelefonosStr = "";
    if (sucursalActualObj.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActualObj.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { }
    }

    const sucursalNomHeader = (sucursalActualObj.nombre || "LABORATORIO").toUpperCase();
    const calleText = [sucursalActualObj.calle, sucursalActualObj.numExterior, sucursalActualObj.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActualObj.colonia || ""} C.P. ${sucursalActualObj.cPostal || ""} ${sucursalActualObj.ciudad || ""}, ${sucursalActualObj.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActualObj.telefono || ""}`;

    // Dibujar Logo
    try {
      doc.addImage(logoLaboratorio, "JPEG", 14, startY, 45, 28);
    } catch (e) { }

    // Rectángulo institucional "INFORMES"
    doc.setFillColor(24, 35, 79);
    doc.rect(115, startY, 81, 7, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("INFORMES", 155.5, startY + 5, { align: "center" });

    // Datos sucursal a la derecha
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text(sucursalNomHeader, 196, startY + 12, { align: "right" });

    let currY = startY + 16;
    if (calleText.trim()) {
      doc.setFont("helvetica", "normal");
      doc.text(`Dirección: ${calleText}`, 196, currY, { align: "right" });
      currY += 4;
    }
    doc.setFont("helvetica", "normal");
    doc.text(colCpText, 196, currY, { align: "right" });
    currY += 4;
    doc.text(telText, 196, currY, { align: "right" });

    // Título del reporte
    const listaActualObj = listasPrecios.find(
      (l) => String(l.idListaPrecio || l.idLista) === String(listaSeleccionada)
    );
    const nombreListaStr = listaActualObj ? (listaActualObj.nombre || listaActualObj.nombreLista || "") : "";

    currY += 8;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(24, 35, 79);
    doc.text("CATÁLOGO DE ESTUDIOS", 14, currY);
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(80, 80, 80);
    doc.text(`Lista de Precios: ${nombreListaStr}`, 14, currY + 4);

    let nextY = currY + 10;
    const totalColsCount =
      8 + (costoSubrogadoCheck ? 1 : 0) + (costoPublicoCheck ? 1 : 0) + (costoInternoCheck ? 1 : 0);

    const bodyRowsPdf = [];

    estudiosFiltrados.forEach((est) => {
      const esPerf = esPerfilEstudio(est);
      const areaNom = areasMap[est.idArea] || est.nombreArea || est.area || "General";
      const tipoEtiqueta = esPerf ? "Perfil" : "Estudio";
      const sinonimosArr = sinonimosMap[est.idEstudio] || est.sinonimos || [];
      const sinonimosStr = Array.isArray(sinonimosArr)
        ? sinonimosArr.filter(Boolean).join(", ")
        : String(sinonimosArr || "").trim();

      const det = getDetallesEstudio(est);
      const indPacLimpia = convertRichTextToPlainText(det.indPacText);
      const indTomaLimpia = convertRichTextToPlainText(det.indTomaText);
      const indEstLimpia = convertRichTextToPlainText(det.indEstText);

      // Fila 1: Código | Área | Nombre del Estudio (Estudio/Perfil)
      bodyRowsPdf.push([
        {
          content: `Código: ${est.codigo || ""}`,
          styles: { fontStyle: "bold", fillColor: [24, 35, 79], textColor: [255, 255, 255] },
        },
        {
          content: `Área: ${areaNom}`,
          styles: { fontStyle: "bold", fillColor: [24, 35, 79], textColor: [255, 255, 255] },
        },
        {
          content: `${est.nombre || ""} (${tipoEtiqueta})`,
          colSpan: totalColsCount - 2,
          styles: { fontStyle: "bold", fillColor: [24, 35, 79], textColor: [255, 255, 255] },
        },
      ]);

      // Fila 2: Sinónimos (si existen)
      if (sinonimosStr !== "") {
        bodyRowsPdf.push([
          {
            content: `Sinónimos: ${sinonimosStr}`,
            colSpan: totalColsCount,
            styles: { fontStyle: "italic", fillColor: [245, 247, 250], textColor: [80, 80, 80], fontSize: 6.5 },
          },
        ]);
      }

      // Fila 3: Fila de Datos
      const subSiNo = esSubrogadoEstudio(est) ? "Si" : "No";

      const cSub = Number(est.costoSubrogado || est.precioSubrogado || 0);
      const cPub = Number(preciosByLista[listaSeleccionada]?.[est.idEstudio] ?? est.precio ?? 0);
      const cInt = Number(est.costoIntPrueba || est.costoInterno || est.costo || 0);

      const rowData = [det.abrev, det.tipoM, det.volCant, det.colorTub, det.tProc, det.tUrg, det.met, subSiNo];
      if (costoSubrogadoCheck) rowData.push(`$${cSub.toFixed(2)}`);
      if (costoPublicoCheck) rowData.push(`$${cPub.toFixed(2)}`);
      if (costoInternoCheck) rowData.push(`$${cInt.toFixed(2)}`);

      bodyRowsPdf.push(rowData);

      // Filas de Indicaciones (UNICAMENTE SI TIENEN CONTENIDO)
      if (indPacienteCheck && indPacLimpia !== "") {
        bodyRowsPdf.push([
          { content: "Indicaciones paciente:", styles: { fontStyle: "bold", fillColor: [255, 248, 225] } },
          { content: indPacLimpia, colSpan: totalColsCount - 1, styles: { fillColor: [255, 248, 225] } },
        ]);
      }

      if (indTomaCheck && indTomaLimpia !== "") {
        bodyRowsPdf.push([
          { content: "Indicaciones toma:", styles: { fontStyle: "bold", fillColor: [238, 242, 246] } },
          { content: indTomaLimpia, colSpan: totalColsCount - 1, styles: { fillColor: [238, 242, 246] } },
        ]);
      }

      if (indEstabilidadCheck && indEstLimpia !== "") {
        bodyRowsPdf.push([
          { content: "Indicaciones estabilidad:", styles: { fontStyle: "bold", fillColor: [240, 244, 248] } },
          { content: indEstLimpia, colSpan: totalColsCount - 1, styles: { fillColor: [240, 244, 248] } },
        ]);
      }
    });

    // Cabeceras de la tabla PDF
    const tableHeadersPdf = [
      "Abreviatura",
      "Tipo muestra",
      "Vol/Cant",
      "Color tubo/material",
      "Tiempo proceso",
      "Tiempo urgente",
      "Método",
      "Estudio subrogado",
    ];
    if (costoSubrogadoCheck) tableHeadersPdf.push("Costo subrogado");
    if (costoPublicoCheck) tableHeadersPdf.push("Costo público");
    if (costoInternoCheck) tableHeadersPdf.push("Costo interno");

    autoTable(doc, {
      startY: nextY,
      head: [tableHeadersPdf],
      body: bodyRowsPdf,
      headStyles: { fillColor: [0, 103, 135], textColor: [255, 255, 255], fontStyle: "bold", fontSize: 7 },
      styles: { fontSize: 6.2, cellPadding: 1.5, halign: "center" },
      columnStyles: { 0: { halign: "left" }, 1: { halign: "left" } },
    });

    // Pie de Página
    const pageCount = doc.internal.getNumberOfPages();
    const hoyImpStr = new Date().toLocaleString();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text(`Impreso: ${hoyImpStr}`, 14, 287);
      doc.text(`Página ${i} de ${pageCount}`, 196, 287, { align: "right" });
    }

        doc.save(`Catalogo_Estudios.pdf`);
      },
      "Generando reporte de Catálogo de Estudios en PDF...",
      "Procesando documento"
    );
  };

  // Renderizar la barra de paginación con el mismo diseño e íconos de ReporteCaja.js
  const renderBarraPaginacion = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        my: 2,
        py: 1,
        width: "100%",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: "bold", color: "#18234f", mr: 1 }}>
        Página:
      </Typography>

      <IconButton
        size="small"
        disabled={page <= 1}
        onClick={() => {
          setPage((prev) => Math.max(1, prev - 1));
          window.scrollTo({ top: 300, behavior: "smooth" });
        }}
        sx={{ color: "#18234f", "&:disabled": { color: "#cccccc" } }}
      >
        <NavigateBeforeIcon fontSize="small" />
      </IconButton>

      {paginasVisibles.map((numPag) => {
        const esActivo = numPag === page;
        return (
          <IconButton
            key={numPag}
            size="small"
            onClick={() => {
              setPage(numPag);
              window.scrollTo({ top: 300, behavior: "smooth" });
            }}
            sx={{
              width: "28px",
              height: "28px",
              fontSize: "0.85rem",
              fontWeight: "bold",
              backgroundColor: esActivo ? "#18234f" : "transparent",
              color: esActivo ? "#ffffff" : "#18234f",
              border: esActivo ? "none" : "1px solid #18234f",
              "&:hover": {
                backgroundColor: esActivo ? "#014e65" : "#e0e0e0",
              },
            }}
          >
            {numPag}
          </IconButton>
        );
      })}

      <IconButton
        size="small"
        disabled={page >= totalPages}
        onClick={() => {
          setPage((prev) => Math.min(totalPages, prev + 1));
          window.scrollTo({ top: 300, behavior: "smooth" });
        }}
        sx={{ color: "#18234f", "&:disabled": { color: "#cccccc" } }}
      >
        <NavigateNextIcon fontSize="small" />
      </IconButton>

      <Typography variant="caption" sx={{ color: "#006787", fontWeight: "bold", ml: 1 }}>
        (Total: {estudiosFiltrados.length} estudios)
      </Typography>
    </Box>
  );

  // Calcular número total de columnas
  const totalColsCount =
    8 + (costoSubrogadoCheck ? 1 : 0) + (costoPublicoCheck ? 1 : 0) + (costoInternoCheck ? 1 : 0);

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            minHeight: "80vh",
            py: 3,
          }}
        >
          <Stack spacing={3} sx={{ width: "100%", pl: "3vw", pr: "10vw", boxSizing: "border-box" }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 4,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              className="paperSol"
            >
              {/* Título Principal */}
              <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mb: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 2vw",
                    borderRadius: "8px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  CATÁLOGO DE ESTUDIOS
                </Typography>
              </Box>

              {/* Filtros de Selección */}
              <Box sx={{ width: "95%", maxWidth: "1200px", mb: 4 }}>
                <Table
                  sx={{
                    width: "100%",
                    backgroundColor: "white",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    overflow: "hidden",
                    "& .MuiTableCell-root": { padding: "10px 14px" },
                  }}
                >
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell colSpan={2} align="center" sx={{ color: "white", fontWeight: "bold", fontSize: "1.05rem" }}>
                        Filtros del Catálogo
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Fila Lista de precios */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", width: "25%", backgroundColor: "#f8f9fa" }}>
                        Lista de precios:
                      </TableCell>
                      <TableCell>
                        <Select
                          size="small"
                          value={listaSeleccionada}
                          onChange={(e) => {
                            setListaSeleccionada(e.target.value);
                            setPage(1);
                          }}
                          sx={{ width: "320px" }}
                        >
                          {listasPrecios.map((l) => (
                            <MenuItem key={l.idListaPrecio || l.idLista} value={String(l.idListaPrecio || l.idLista)}>
                              {l.nombre || l.nombreLista}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    </TableRow>

                    {/* Fila Tipo (Estudio / Perfil) */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        Tipo:
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={tipoEstudio}
                                onChange={(e) => {
                                  setTipoEstudio(e.target.checked);
                                  setPage(1);
                                }}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Estudio</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={tipoPerfil}
                                onChange={(e) => {
                                  setTipoPerfil(e.target.checked);
                                  setPage(1);
                                }}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Perfil</Typography>}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>

                    {/* Fila Ordenamiento */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        Ordenamiento:
                      </TableCell>
                      <TableCell>
                        <RadioGroup
                          row
                          value={ordenamiento}
                          onChange={(e) => {
                            setOrdenamiento(e.target.value);
                            setPage(1);
                          }}
                        >
                          <FormControlLabel value="codigo" control={<Radio size="small" sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }} />} label={<Typography variant="body2">Por código</Typography>} />
                          <FormControlLabel value="nombre" control={<Radio size="small" sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }} />} label={<Typography variant="body2">Alfabéticamente</Typography>} />
                          <FormControlLabel value="area" control={<Radio size="small" sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }} />} label={<Typography variant="body2">Por área</Typography>} />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>

                    {/* Fila Subrogado */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        Subrogado:
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={subrogadoSi}
                                onChange={(e) => {
                                  setSubrogadoSi(e.target.checked);
                                  setPage(1);
                                }}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Subrogados</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={subrogadoNo}
                                onChange={(e) => {
                                  setSubrogadoNo(e.target.checked);
                                  setPage(1);
                                }}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">No subrogados</Typography>}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>

                    {/* Fila Seleccione los costos que desea mostrar */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        Seleccione los costos que desea mostrar:
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={costoSubrogadoCheck}
                                onChange={(e) => setCostoSubrogadoCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">C. subrogado</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={costoPublicoCheck}
                                onChange={(e) => setCostoPublicoCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">C. Publico</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={costoInternoCheck}
                                onChange={(e) => setCostoInternoCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">C. Interno</Typography>}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>

                    {/* Fila Seleccione las indicaciones que desea mostrar */}
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        Seleccione las indicaciones que desea mostrar:
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={indPacienteCheck}
                                onChange={(e) => setIndPacienteCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Indicaciones del paciente</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={indTomaCheck}
                                onChange={(e) => setIndTomaCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Indicaciones de la toma</Typography>}
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={indEstabilidadCheck}
                                onChange={(e) => setIndEstabilidadCheck(e.target.checked)}
                                size="small"
                                sx={{ color: "#006787", "&.Mui-checked": { color: "#006787" } }}
                              />
                            }
                            label={<Typography variant="body2">Indicaciones de estabilidad</Typography>}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>

              {/* Contenedor Principal de Paginación y Tabla Unificada */}
              {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                  <CircularProgress sx={{ color: "#006787" }} />
                </Box>
              ) : estudiosFiltrados.length === 0 ? (
                <Box
                  sx={{
                    width: "95%",
                    maxWidth: "1200px",
                    textAlign: "center",
                    py: 4,
                    mb: 3,
                    backgroundColor: "#fff8e1",
                    borderRadius: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ color: "#b78103", fontWeight: "bold" }}>
                    No existen estudios que coincidan con los filtros seleccionados.
                  </Typography>
                </Box>
              ) : (
                <Box sx={{ width: "95%", maxWidth: "1200px", mb: 4 }}>
                  {/* Paginación ARRIBA de la Tabla Header estilo ReporteCaja.js */}
                  {renderBarraPaginacion()}

                  {/* Única Tabla Unificada */}
                  <Table
                    sx={{
                      width: "100%",
                      backgroundColor: "white",
                      border: "1px solid #c4d1db",
                      borderRadius: "8px",
                      overflow: "hidden",
                      mb: 3,
                      "& .MuiTableCell-root": { padding: "8px 10px", fontSize: "0.82rem" },
                    }}
                  >
                    {/* Cabecera Única al Principio de la Tabla */}
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#006787" }}>
                        <TableCell sx={{ color: "white", fontWeight: "bold", width: "12%", backgroundColor: "#006787" }}>Abreviatura</TableCell>
                        <TableCell sx={{ color: "white", fontWeight: "bold", width: "15%", backgroundColor: "#006787" }}>Tipo muestra</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Vol/Cant</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Color tubo/material</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Tiempo proceso</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Tiempo urgente</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Método</TableCell>
                        <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Estudio subrogado</TableCell>
                        {costoSubrogadoCheck && <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Costo subrogado</TableCell>}
                        {costoPublicoCheck && <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Costo público</TableCell>}
                        {costoInternoCheck && <TableCell align="center" sx={{ color: "white", fontWeight: "bold", backgroundColor: "#006787" }}>Costo interno</TableCell>}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {estudiosPaginados.map((est) => {
                        const esPerf = esPerfilEstudio(est);
                        const areaNom = areasMap[est.idArea] || est.nombreArea || est.area || "General";
                        const tipoEtiqueta = esPerf ? "Perfil" : "Estudio";
                        const sinonimosArr = sinonimosMap[est.idEstudio] || est.sinonimos || [];
                        const sinonimosStr = Array.isArray(sinonimosArr)
                          ? sinonimosArr.filter(Boolean).join(", ")
                          : String(sinonimosArr || "").trim();

                        const det = getDetallesEstudio(est);
                        const subSiNo = esSubrogadoEstudio(est) ? "Si" : "No";

                        const cSub = Number(est.costoSubrogado || est.precioSubrogado || 0);
                        const cPub = Number(preciosByLista[listaSeleccionada]?.[est.idEstudio] ?? est.precio ?? 0);
                        const cInt = Number(est.costoIntPrueba || est.costoInterno || est.costo || 0);

                        // Limpieza de rich text de indicaciones (ReactQuill HTML a Texto Plano)
                        const indPacLimpia = convertRichTextToPlainText(det.indPacText);
                        const indTomaLimpia = convertRichTextToPlainText(det.indTomaText);
                        const indEstLimpia = convertRichTextToPlainText(det.indEstText);

                        return (
                          <React.Fragment key={est.idEstudio}>
                            {/* Fila Encabezado de Cada Estudio (Código | Área | Nombre del Estudio en Azul Oscuro #18234f) */}
                            <TableRow sx={{ backgroundColor: "#18234f", borderTop: "2px solid #006787" }}>
                              <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f" }}>
                                Código: {est.codigo || ""}
                              </TableCell>
                              <TableCell sx={{ color: "white", fontWeight: "bold", backgroundColor: "#18234f" }}>
                                Área: {areaNom}
                              </TableCell>
                              <TableCell colSpan={totalColsCount - 2} sx={{ color: "white", fontWeight: "bold", fontSize: "0.95rem", backgroundColor: "#18234f" }}>
                                {est.nombre || ""} ({tipoEtiqueta})
                              </TableCell>
                            </TableRow>

                            {/* Fila Sinónimos (se muestra únicamente si existen) */}
                            {sinonimosStr !== "" && (
                              <TableRow sx={{ backgroundColor: "#f5f7fa" }}>
                                <TableCell colSpan={totalColsCount} sx={{ fontStyle: "italic", fontSize: "0.8rem", color: "#555", pl: 3 }}>
                                  Sinónimos: {sinonimosStr}
                                </TableCell>
                              </TableRow>
                            )}

                            {/* Fila de Datos del Estudio */}
                            <TableRow sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}>
                              <TableCell>{det.abrev}</TableCell>
                              <TableCell>{det.tipoM}</TableCell>
                              <TableCell align="center">{det.volCant}</TableCell>
                              <TableCell align="center">{det.colorTub}</TableCell>
                              <TableCell align="center">{det.tProc}</TableCell>
                              <TableCell align="center">{det.tUrg}</TableCell>
                              <TableCell align="center">{det.met}</TableCell>
                              <TableCell align="center" sx={{ fontWeight: "bold" }}>{subSiNo}</TableCell>
                              {costoSubrogadoCheck && <TableCell align="center" sx={{ fontWeight: "bold" }}>${cSub.toFixed(2)}</TableCell>}
                              {costoPublicoCheck && <TableCell align="center" sx={{ fontWeight: "bold", color: "#2e7d32" }}>${cPub.toFixed(2)}</TableCell>}
                              {costoInternoCheck && <TableCell align="center" sx={{ fontWeight: "bold", color: "#18234f" }}>${cInt.toFixed(2)}</TableCell>}
                            </TableRow>

                            {/* Filas de Indicaciones (UNICAMENTE SI TIENEN CONTENIDO NO VACIO Y ESTAN ACTIVAS EN EL FILTRO) */}
                            {indPacienteCheck && indPacLimpia !== "" && (
                              <TableRow sx={{ backgroundColor: "#fff8e1" }}>
                                <TableCell sx={{ fontWeight: "bold", fontSize: "0.8rem", color: "#b78103" }}>
                                  Indicaciones paciente:
                                </TableCell>
                                <TableCell colSpan={totalColsCount - 1} sx={{ fontSize: "0.8rem", color: "#b78103", whiteSpace: "pre-line" }}>
                                  {indPacLimpia}
                                </TableCell>
                              </TableRow>
                            )}

                            {indTomaCheck && indTomaLimpia !== "" && (
                              <TableRow sx={{ backgroundColor: "#eef2f6" }}>
                                <TableCell sx={{ fontWeight: "bold", fontSize: "0.8rem", color: "#18234f" }}>
                                  Indicaciones toma:
                                </TableCell>
                                <TableCell colSpan={totalColsCount - 1} sx={{ fontSize: "0.8rem", color: "#18234f", whiteSpace: "pre-line" }}>
                                  {indTomaLimpia}
                                </TableCell>
                              </TableRow>
                            )}

                            {indEstabilidadCheck && indEstLimpia !== "" && (
                              <TableRow sx={{ backgroundColor: "#f0f4f8" }}>
                                <TableCell sx={{ fontWeight: "bold", fontSize: "0.8rem", color: "#006787" }}>
                                  Indicaciones estabilidad:
                                </TableCell>
                                <TableCell colSpan={totalColsCount - 1} sx={{ fontSize: "0.8rem", color: "#006787", whiteSpace: "pre-line" }}>
                                  {indEstLimpia}
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>

                  {/* Paginación ABAJO de la Tabla */}
                  {renderBarraPaginacion()}
                </Box>
              )}
            </Paper>
          </Stack>
        </Box>

        {/* Botón Flotante Lateral Derecho: PDF */}
        <Box
          sx={{
            position: "fixed",
            right: "3vw",
            top: "35vh",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            zIndex: 1000,
          }}
        >
          <Tooltip
            title="Exportar Catálogo a PDF"
            arrow
            placement="left"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.85vw",
                  padding: "0.5vw 0.8vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(24, 35, 79, 0.9)",
                  fontWeight: "bold",
                  color: "#ffffff",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(24, 35, 79, 0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={handleExportarPDF}
              sx={{
                backgroundColor: "#ffffff",
                color: "#d32f2f",
                boxShadow: 3,
                border: "1px solid #e0e0e0",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "3.5vw",
                height: "3.5vw",
                minWidth: "48px",
                minHeight: "48px",
              }}
            >
              <Icon path={mdiFilePdfBox} size={1.5} color="#d32f2f" />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};

export default CatalogoEstudios;
